import { KEYS } from 'app/constants/SceneConstants';
import SceneBaseTT from './SceneBaseTT';

export default class Welcome extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.Welcome, active: false });
  }

  create() {
    super.create();
    this.setBackgroundImage('background_purple');
    this.add.spine(840, 360, 'pulse', 'intro', true, true);
    this.add.image(840, 213, 'locale_text', 'logo_game');
    this.add.spine(840, 360, 'intro_end', 'intro', true, true);
    this.game.hud.setState('WELCOME');

    this.game.soundController.playMusic('landing_page');
  }

  handleStartGame() {
    this.game.showIntro();
  }

  shutdown() {
    super.shutdown();
  }
}
